export default __webpack_public_path__ + "static/media/ts.eeb913e1.png";